export const PAGE_LIST = 'list';
export const PAGE_ADD = 'add';
export const PAGE_EDIT = 'edit';